import request from '@/utils/request'

/**
 * 获取顶部公告
 */
export function getTopNotice() {
  return request({
    url: '/v1/notice/top',
    method: 'get'
  })
}

/**
 * 发布系统通知
 */
export function publishSystemNotice(data) {
  return request({
    url: '/system/notice/publish',
    method: 'post',
    data
  })
}
